import {
  IPaginationSet,
  ResponseModel,
  IAdsModel,
  IPostAdsModel
} from "@/models";
import VetQuestApi from "./VetQuestApi";

export abstract class PostService {
  static BASE_URL: string = "post";
  static async GetAdsBySearch(
    pageIndex: number,
    pageSize: number,
    searchText: string,
    stateId?: number,
    categoryId?: number,
    startDate?: Date,
    endDate?: Date
  ): Promise<ResponseModel<IPaginationSet<IAdsModel>>> {
    let response = new ResponseModel<IPaginationSet<IAdsModel>>(
      0,
      {} as IPaginationSet<IAdsModel>
    );
    try {
      const param = {
        stateId: stateId,
        categoryId: categoryId,
        startDate: startDate,
        endDate: endDate,
        searchText: searchText,
        pageIndex: pageIndex,
        pageSize: pageSize
      };
      const { data, status } = await VetQuestApi().post(
        `${this.BASE_URL}/search`,
        param
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IPaginationSet<IAdsModel>>(
        error.response.status,
        {} as IPaginationSet<IAdsModel>,
        error.response
      );
      return response;
    }
  }

  static async Create(model: IPostAdsModel): Promise<ResponseModel<IAdsModel>> {
    let response = new ResponseModel<IAdsModel>(0, {} as IAdsModel);
    const formData = new FormData();
    // Append each field from `model`
    Object.keys(model).forEach(field => {
      if (Array.isArray(model[field])) {
          // If the field is an array (e.g., files), append each file separately
            if(field == "files"){
              model[field].forEach((file: File) => {
                formData.append('Files', file); // Ensure "Files" matches C# model
            });
          }
      } else {
          formData.append(field, model[field]);
      }
    });
    try {      
      const { data, status } = await VetQuestApi().post(
        this.BASE_URL,
        formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        },
      );
      if (status === 200) {
        response = new ResponseModel<IAdsModel>(200, data);
      }
    } catch (err) {
      console.log(err);
      response.status = err.response.status;
      response.error = err.response;
    }
    return response;
  }

  static async Edit(
    id: number,
    model: IPostAdsModel
  ): Promise<ResponseModel<IAdsModel>> {
    let response = new ResponseModel<IAdsModel>(0, {} as IAdsModel);
    const formData = new FormData();
    // Append each field from `model`
    Object.keys(model).forEach(field => {
      if (Array.isArray(model[field])) {
          // If the field is an array (e.g., files), append each file separately
            if(field == "files"){
              model[field].forEach((file: File) => {
                formData.append('Files', file); // Ensure "Files" matches C# model
            });
          }
      } else {
          formData.append(field, model[field]);
      }
    });
    try {
      const { data, status } = await VetQuestApi().put(
        `${this.BASE_URL}/${id}`,
        formData
      );
      if (status === 200) {
        response = new ResponseModel<IAdsModel>(200, data);
      }
    } catch (err) {
      response.status = err.response.status;
      response.error = err.response;
    }
    return response;
  }

  static async Extend(adId: number, password: string){
    let response = new ResponseModel<IAdsModel>(0, {} as IAdsModel);
    try {
      const { data, status } = await VetQuestApi().put(
        `${this.BASE_URL}/extend/${adId}`, { password } );
      if (status === 200) {
        response = new ResponseModel<IAdsModel>(200, data);
      }
    } catch (err) {
      console.log(err);
      response.status = err.response.status;
      response.error = err.response;
    }
    return response;
  }
  static async Delete(adId: number): Promise<ResponseModel<IAdsModel>> {
    let response = new ResponseModel<IAdsModel>(0, {} as IAdsModel);
    try {
      const { data, status } = await VetQuestApi().delete(`${this.BASE_URL}`, {
        params: {
          id: adId
        }
      });
      if (status === 200) {
        response = new ResponseModel<IAdsModel>(200, data);
      }
    } catch (err) {
      response.status = err.response.status;
      response.error = err.response;
    }
    return response;
  }

  static async GetDetail(adId: number): Promise<ResponseModel<IAdsModel>> {
    let response = new ResponseModel<IAdsModel>(0, {} as IAdsModel);
    try {
      const { data, status } = await VetQuestApi().get(
        `${this.BASE_URL}/Detail`,
        {
          params: {
            id: adId
          }
        }
      );
      if (status === 200) {
        response = new ResponseModel<IAdsModel>(200, data);
      }
    } catch (err) {
      response.status = err.response.status;
      response.error = err.response;
    }
    return response;
  }
}
